import { render, staticRenderFns } from "./fanx.vue?vue&type=template&id=ae758d6a&scoped=true&"
import script from "./fanx.vue?vue&type=script&lang=js&"
export * from "./fanx.vue?vue&type=script&lang=js&"
import style0 from "./fanx.vue?vue&type=style&index=0&id=ae758d6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae758d6a",
  null
  
)

export default component.exports